import React from 'react';
import UserSidebar from '../Sidebar/Sidebar';

const Dashboard = () => {
    return (
        <>
           <UserSidebar/>
            
        </>
    );
};

export default Dashboard;